export function cleanupSocketSubscription({ socket, event }) {
  // Unsubscribe from socket events here
  if (socket) {
    socket.off(event);
  }
}
